import {
    IAccountMappingTemplateGroup,
    IAccountMappingTemplateGroupItemSubtotal,
} from '@modeso/types__aumico-lib-annualreport-be';

export interface IAddSubtotalEvent {
    subtotal: IAccountMappingTemplateGroupItemSubtotal;
    parent: IAccountMappingTemplateGroup;
    index?: number;
    placeSubtotalAsFirstItem: boolean;
}
